exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-link[data-v-028a465f]:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", ""]);
